import formatCurrencyValueByLocale from './format-currency-value-by-locale'
import formatNumberByLocale from './format-number-by-locale'
import { isEmptyValue } from './object-utils'
import formatDateByLocale from './format-date-by-locale'
import moment from 'moment'

export const EMPTY_VALUE_PLACEHOLDER = '-'
export const ATTRIBUTE_VALUE_TYPES = {
  STRING: 'string',
  INTEGER: 'integer',
  CURRENCY: 'currency',
  DATE: 'date',
  CHIP: 'chip'
}
export const formatAttributeDataValue = (productData, attributeId, attributeConfig) => {
  const value = productData[attributeId]
  let type = ''
  let returnValue: any = {
    value: EMPTY_VALUE_PLACEHOLDER,
    type: 'string'
  }
  const attributeFormatMetadata = attributeConfig?.attributeFormatMetadata || null
  if (isEmptyValue(value)) {
    return {
      ...returnValue,
      value: EMPTY_VALUE_PLACEHOLDER
    }
  }
  let relatedAttributes = []
  if (attributeFormatMetadata) {
    type = attributeFormatMetadata.type
    relatedAttributes = attributeFormatMetadata?.relatedAttributes || []
  }
  let params: any = {}
  try {
    switch (type) {
      case ATTRIBUTE_VALUE_TYPES.CURRENCY:
        if (isNaN(Number(value))) {
          returnValue = {
            ...returnValue,
            value: EMPTY_VALUE_PLACEHOLDER
          }
        } else {
          params = fractionParams(attributeFormatMetadata)
          if (relatedAttributes?.length) {
            const currencyCode = productData[relatedAttributes[0]]
            returnValue = {
              ...returnValue,
              value: formatCurrencyValueByLocale(
                currencyCode,
                value,
                params.minimumFractionDigits,
                params.maximumFractionDigits
              )
            }
          } else {
            returnValue = {
              ...returnValue,
              value
            }
          }
        }
        break
      case ATTRIBUTE_VALUE_TYPES.INTEGER:
        if (isNaN(Number(value))) {
          returnValue = {
            ...returnValue,
            value: EMPTY_VALUE_PLACEHOLDER
          }
        } else {
          params = fractionParams(attributeFormatMetadata)
          returnValue = {
            ...returnValue,
            value: formatNumberByLocale(
              value,
              params.minimumFractionDigits,
              params.maximumFractionDigits
            ).toString()
          }
        }

        break
      case ATTRIBUTE_VALUE_TYPES.DATE:
        try {
          let format = attributeFormatMetadata.format
          if (attributeFormatMetadata.isDateTime) {
            if (!format) {
              format = {
                hour: 'numeric',
                minute: '2-digit',
                hour12: false
              }
            }
            returnValue = {
              ...returnValue,
              value: formatDateByLocale(value, format)
            }
          } else {
            returnValue = {
              ...returnValue,
              value: formatDateByLocale(value)
            }
          }
          break
        } catch (e) {
          console.error(e)
          returnValue = {
            ...returnValue,
            value: EMPTY_VALUE_PLACEHOLDER
          }
        }
        break
      case ATTRIBUTE_VALUE_TYPES.CHIP:
        let chipsData = []
        const colorsData = productData[attributeFormatMetadata.colorAttribute] || []
        const statusData = productData[attributeFormatMetadata.statusAttribute] || []

        if (Array.isArray(value)) {
          value.forEach((el, ind) => {
            chipsData.push({
              title: el,
              color: colorsData?.[ind],
              clusterStatus: statusData?.[ind]
            })
          })
        } else {
          const datesToolTip = attributeFormatMetadata.dateRangeAttributes
            ? getDateRangeText(productData, attributeFormatMetadata)
            : ''
          chipsData = [
            {
              title: value,
              color: colorsData?.[0],
              clusterStatus: statusData?.[0],
              ...(datesToolTip ? { tooltip: `${value} \n ${datesToolTip}` } : {})
            }
          ]
        }
        returnValue = {
          ...returnValue,
          value: chipsData,
          type: ATTRIBUTE_VALUE_TYPES.CHIP
        }
        break
      default:
        if (Array.isArray(value)) {
          returnValue = {
            ...returnValue,
            value: value.filter(el => el).join(', ')
          }
        } else {
          returnValue = {
            ...returnValue,
            value: String(value)
          }
        }
    }
  } catch (e) {
    returnValue = {
      ...returnValue,
      value: EMPTY_VALUE_PLACEHOLDER
    }
  }
  return returnValue
}

const fractionParams = attributeFormatMetadata => {
  const params: any = {}
  if (!isEmptyValue(attributeFormatMetadata.minimumFractionDigits)) {
    params.minimumFractionDigits = attributeFormatMetadata.minimumFractionDigits
  }
  if (!isEmptyValue(attributeFormatMetadata.maximumFractionDigits)) {
    params.maximumFractionDigits = attributeFormatMetadata.maximumFractionDigits
  }
  return params
}

const getDateRangeText = (productData, attributeFormatMetadata) => {
  let dateRangeData = []
  attributeFormatMetadata.dateRangeAttributes.forEach(el => {
    if (productData[el]) {
      const temp = moment(new Date(productData[el])).format('DD-MMM-YYYY')
      dateRangeData.push(temp)
    }
  })
  return dateRangeData.join(' To ')
}
